import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";
import swal from "sweetalert2";

@Component({
  selector: "app-customer-banks",
  templateUrl: "./customer-banks.component.html",
  styleUrls: ["./customer-banks.component.css"],
})
export class CustomerBanksComponent implements OnInit {
  banks: any[] = [];
  banks_raw_data: any;
  base_url_for_pagination: any;
  current_page: any;

  constructor(
    private userService: UserServiceService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private leadsService: LeadsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getBanks();
  }

  getBanks() {
    this.slimLoadingBarService.start();
    this.userService.getCustomerBanks().subscribe(
      (data: any) => {
        this.banks_raw_data = data;
        this.banks = data && data.data ? data.data : data || [];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  editBank(id) {
    this.router.navigate([`/pages/settings/customer-banks/edit/${id}`]);
  }

  deleteBank(id) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this bank!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.userService.deleteCustomerBank(id).subscribe(
          () => {
            swal("Success", "Bank deleted successfully", "success");
            this.getBanks();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
      } else {
        swal("Cancelled", "", "error");
      }
    });
  }

  pageChange(ev) {
    const selectedUrl = `${this.base_url_for_pagination}?page=${ev}`;
    this.infinite(selectedUrl, ev);
  }

  infinite(url, event) {
    this.leadsService.infinteWithPaginated(url).subscribe(
      (data: any) => {
        this.banks_raw_data = data;
        this.base_url_for_pagination = data.last_page_url.split("?")[0];
        this.banks = data.data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/customer-banks/customer-banks.component.ts